enum Envs {
  AIRLOCK_BE_URL = 'REACT_APP_AIRLOCK_BE_URL',
  AIRLOCK_BE_PREFIX = 'REACT_APP_AIRLOCK_BE_PREFIX',
  AIRLOCK_BE_PREFIX_V2 = 'REACT_APP_AIRLOCK_BE_PREFIX_V2',
  API_BE_URL = 'REACT_APP_API_BE_URL',
  API_BE_PREFIX = 'REACT_APP_API_BE_PREFIX',
  AIRLOCK_FE_BASE_URL = 'REACT_APP_AIRLOCK_FE_BASE_URL',
  AIRLOCK_HELPDESK_URL = 'REACT_APP_AIRLOCK_HELPDESK_URL',
  AIRLOCK_REQUESTS_V3_ROUTES_ENABLED = 'REACT_APP_AIRLOCK_REQUESTS_V3_ROUTES_ENABLED',
  RELATED_DAR_ENABLED = 'REACT_APP_RELATED_DAR_ENABLED',
  ADDITIONAL_INFO_FORM_ENABLED = 'REACT_APP_ADDITIONAL_INFO_FORM_ENABLED'
}

export const getEnv = (envName: string): string | boolean | undefined => {
  // @ts-ignore
  if (window._env_ && Object.prototype.hasOwnProperty.call(window._env_, envName)) {
    // @ts-ignore
    return window._env_[envName]
  }

  return process.env[envName]
}

export const castToStringOrUseDefault = (envVariableName: Envs, defaultValue: string): string => {
  const envValue = getEnv(envVariableName)
  return envValue === undefined || envValue === null || envValue === '' || envValue === 'None'
    ? defaultValue
    : String(envValue)
}

export const castToBoolOrUseDefault = (envVariableName: Envs, defaultValue: boolean): boolean => {
  const envValue = getEnv(envVariableName)

  if (envValue === undefined || envValue === null || envValue === '' || envValue === 'None') {
    return defaultValue
  }

  if (envValue === true || envValue === 'true') {
    return true
  }

  if (envValue === false || envValue === 'false') {
    return false
  }

  return defaultValue
}

const getAirlockBePrefix = (version?: string): string => {
  switch (version) {
    case 'v2':
      return castToStringOrUseDefault(Envs.AIRLOCK_BE_PREFIX_V2, '/airlock-api/v2')
    default:
      return castToStringOrUseDefault(Envs.AIRLOCK_BE_PREFIX, '')
  }
}

export const getAirlockBeUrl = (version?: string): string => {
  const url = castToStringOrUseDefault(Envs.AIRLOCK_BE_URL, window.location.origin)
  const prefix = getAirlockBePrefix(version)
  return `${url}${prefix}`
}

export const getApiServerBeUrl = (): string => {
  const url = castToStringOrUseDefault(Envs.API_BE_URL, window.location.origin.replace('airlock.', ''))
  const prefix = castToStringOrUseDefault(Envs.API_BE_PREFIX, '/api/v1')
  return `${url}${prefix}`
}

export const isAirlockRequestsV3RoutesEnabled = (): boolean =>
  castToBoolOrUseDefault(Envs.AIRLOCK_REQUESTS_V3_ROUTES_ENABLED, false)

export const isRelatedDarEnabled = (): boolean => castToBoolOrUseDefault(Envs.RELATED_DAR_ENABLED, false)

export const isAdditionalInfoFormEnabled = (): boolean =>
  castToBoolOrUseDefault(Envs.ADDITIONAL_INFO_FORM_ENABLED, false)

export default Envs
